import RefNavbar from './RefNavbar';
import RefHome from './RefHome';

function Page2026() {
  return (
    <>
      <RefNavbar />
      <RefHome />
    </>
  );
}

export default Page2026;
